/*
 * GA4 custom events for the current shop (Phase 1). Every event goes through window.trTrack
 * (snippets/tr-analytics.liquid). All listeners are delegated on document, so they keep working
 * after AJAX re-renders (filters, sort, hot buttons, load more).
 *
 * Markup hooks:
 *   data-tr-item                   card JSON (snippets/tr-item-data.liquid, related-by-vendor2 cards)
 *   data-tr-list-id / -list-name   product list container; -offset / -page from paginate
 *   data-tr-entry                  search input entry point
 *   data-tr-search-term            search page input when a search was performed
 *   data-tr-suggestion / -index    predictive search option
 *   data-tr-filter-source          facet form (sidebar / drawer)
 *   data-tr-filter-name / -value   facet checkbox; data-tr-filter-name on <price-range>
 */
(function () {
  if (window.trAnalyticsReady) return;
  window.trAnalyticsReady = true;

  // Console logging only on a non-live theme (role known and not 'main'), or anywhere with localStorage tr_debug set.
  var isDev = !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main');
  try {
    if (window.localStorage.getItem('tr_debug')) isDev = true;
  } catch (e) {}

  function track(name, params) {
    params = compact(params);
    // Outside the live theme, log every event: one gtag request can batch several events, so Network alone is ambiguous.
    if (isDev) console.info('[trTrack]', name, params);
    if (typeof window.trTrack === 'function') window.trTrack(name, params);
  }

  var CONDITIONS = {
    'neu': 'Neu',
    'neuwertig': 'Neuwertig',
    'sehr gut': 'Sehr gut',
    'sehr guter zustand': 'Sehr gut',
    'gut': 'Gut',
    'guter zustand': 'Gut'
  };

  function normalizeCondition(raw) {
    if (!raw) return undefined;
    var grade = CONDITIONS[String(raw).toLowerCase().trim()];
    if (!grade && isDev) console.warn('[trTrack] unmapped item_condition:', raw);
    return grade;
  }

  function parseJson(value) {
    try {
      return JSON.parse(value);
    } catch (e) {
      return null;
    }
  }

  function compact(obj) {
    Object.keys(obj).forEach(function (key) {
      if (obj[key] === undefined || obj[key] === null || obj[key] === '') delete obj[key];
    });
    return obj;
  }

  function listParams(list) {
    return { item_list_id: list.dataset.trListId, item_list_name: list.dataset.trListName };
  }

  /* select_item: a click on any product link inside a tagged list. Buttons (add to cart, swatches) are ignored. */
  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest && event.target.closest('a[href]');
      if (!link) return;
      var card = link.closest('[data-tr-item]');
      var list = card && card.closest('[data-tr-list-id]');
      if (!list) return;
      var data = parseJson(card.dataset.trItem);
      if (!data) return;

      var position = Array.prototype.indexOf.call(list.querySelectorAll('[data-tr-item]'), card);
      var params = listParams(list);
      var item = compact({
        item_id: data.item_id,
        item_name: data.item_name,
        item_brand: data.item_brand,
        item_category: data.item_category,
        item_variant: data.item_variant,
        price: data.price,
        index: (parseInt(list.dataset.trOffset, 10) || 0) + position,
        item_condition: normalizeCondition(data.condition),
        item_list_id: params.item_list_id,
        item_list_name: params.item_list_name
      });

      track('select_item', Object.assign(params, { items: [item], transport_type: 'beacon' }));
    },
    true
  );

  /* view_search_results: once per search page view. */
  function trackSearchResults() {
    var input = document.querySelector('[data-tr-search-term]');
    if (input && input.dataset.trSearchTerm) {
      track('view_search_results', { search_term: input.dataset.trSearchTerm });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackSearchResults);
  } else {
    trackSearchResults();
  }

  /* search_focus: once per input per page view. */
  var focusedInputs = typeof WeakSet === 'function' ? new WeakSet() : null;
  document.addEventListener('focusin', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('input[name="q"]:not([type="hidden"])') || !focusedInputs) return;
    if (focusedInputs.has(input)) return;
    focusedInputs.add(input);
    track('search_focus', { entry_point: input.dataset.trEntry || 'other' });
  });

  /* search_suggestion_click: predictive search options, incl. the "Nach … suchen" button (query). */
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target.closest && event.target.closest('a[href], button');
      if (!target) return;
      var option = target.closest('[data-tr-suggestion]');
      if (!option) return;
      var root = option.closest('predictive-search');
      var input = root && root.querySelector('input[name="q"]');
      track('search_suggestion_click', {
        search_term: input ? input.value.trim() : undefined,
        suggestion_type: option.dataset.trSuggestion,
        index: parseInt(option.dataset.trIndex, 10) || 0,
        transport_type: 'beacon'
      });
    },
    true
  );

  function wholeEuros(input) {
    var value = input ? parseFloat(input.value) : NaN;
    return isNaN(value) ? '' : String(Math.trunc(value));
  }

  /* filter_apply (facets): one event per value that gets checked. Unchecking is not an apply. */
  document.addEventListener('change', function (event) {
    var input = event.target;
    var form = input.closest && input.closest('[data-tr-filter-source]');
    if (!form) return;

    if (input.type === 'checkbox' && input.dataset.trFilterName) {
      if (!input.checked) return;
      track('filter_apply', {
        filter_name: input.dataset.trFilterName,
        filter_value: input.dataset.trFilterValue || input.value,
        filter_source: form.dataset.trFilterSource
      });
      return;
    }

    var range = input.closest('price-range');
    if (range) {
      var min = range.querySelector('input.rulerinput-min');
      var max = range.querySelector('input.rulerinput-max');
      track('filter_apply', {
        filter_name: range.dataset.trFilterName || 'Preis',
        filter_value: wholeEuros(min) + '-' + wholeEuros(max),
        filter_source: form.dataset.trFilterSource
      });
    }
  });

  /* filter_apply (hot button chips): only chips that set a filter, only when switching on. */
  document.addEventListener(
    'click',
    function (event) {
      var chip = event.target.closest && event.target.closest('.hot-buttons__btn');
      if (!chip || chip.dataset.active === 'true') return;
      var param = chip.dataset.filterParam;
      var value = chip.dataset.filterValue;
      if (!param || !value) return;

      // Readable values: the facet's label for the name, the chip text (without the emoji) for the value.
      var label = chip.cloneNode(true);
      label.querySelectorAll('[aria-hidden="true"]').forEach(function (el) {
        el.remove();
      });
      var chipText = label.textContent.replace(/\s+/g, ' ').trim();
      var facet = null;
      document.querySelectorAll('input[data-tr-filter-name], price-range[data-tr-filter-name]').forEach(function (el) {
        if (facet) return;
        if (el.name === param) facet = el;
        else if (el.tagName === 'PRICE-RANGE' && Array.prototype.some.call(el.querySelectorAll('input'), function (i) { return i.name === param; })) facet = el;
      });
      track('filter_apply', {
        filter_name: facet ? facet.dataset.trFilterName : chipText,
        filter_value: chipText,
        filter_source: 'chip'
      });
    },
    true
  );

  /* sort_change */
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select.matches || !select.matches('select[name="sort_by"]')) return;
    track('sort_change', { sort_option: select.value });
  });

  /* load_more: dispatched by LoadMore (assets/global.js) after a page was appended. */
  document.addEventListener('tr:load-more', function () {
    var list = document.getElementById('product-grid');
    if (!list || !list.dataset.trListId) return;
    var page = (parseInt(list.dataset.trPage, 10) || 1) + 1;
    list.dataset.trPage = page;
    track('load_more', Object.assign(listParams(list), { page: page }));
  });
})();
